import type { ApiCacheOptions } from '@shared/util/request'
import { MINUTE_IN_MS } from '@shared/util/date'
import { ApiOptions, getRequest, getRequestWithCache } from './index'
import type { USER_ROLE } from '@/constants'
import { getSchoolSymbol } from '@/router/util'

export interface UserModuleInfo {
  id: number
  type: number
  role: number
  schoolId: number
  schoolUserId: number
  photo: string
  globalUserName: string
  displayName: string
  phone: string
  userModuleTreeNodeUIDataList: Module[]
  navList: Module[]
}
export interface Action {
  action: string
  allowed: boolean
}
export interface Module {
  id: number
  name: string
  icon: string
  activeIcon: string
  url: string
  children: Module[]
  actions: Action[]
}
export const getUserModuleInfo = (userRole: USER_ROLE, cacheOptions?: ApiCacheOptions) => {
  return getRequestWithCache<UserModuleInfo>(
    new ApiOptions({
      url: `/${getSchoolSymbol()}/${userRole}/user/info`,
    }),
    { expireTime: MINUTE_IN_MS, ...cacheOptions },
  )
}

export interface UserAccountInfo {
  id: number
  name: string
  displayName: string
  gender: string
  phone: string
  email: string
  address: string
  identityCard: string
  photoUrl: string
  userType: number
  phoneValid: boolean
  pwdStrong: boolean
  nationality: string
  birthday: number
  userSchools: UserSchool[]
}
export interface UserSchool {
  id: number
  name: string
  symbol: string
  logoUrl: string
  userRole: number
  roleName: string
  category: number
  type: number // 1: 字谱2.0 2: 字谱3.0
}

export const getUserInfo = (cacheOptions: ApiCacheOptions = {}) => {
  return getRequestWithCache<UserAccountInfo>(
    new ApiOptions({
      url: '/account/info',
    }),
    cacheOptions,
  )
}

export const validUser = () => {
  return getRequest(
    new ApiOptions({
      url: '/user/valid',
    }),
  )
}
